import React from 'react';
import { StyledSticky } from './sticky.style';
import { useSticky } from '../../../hooks/use-sticky/use-sticky';

interface ISticky {
    children: (sticky: boolean) => JSX.Element;
    height?: number; // define a specific sticky height / otherwise it's automatically calculated
    observerRef: React.RefObject<HTMLElement | null>;
}

/**
 * The Sticky component, that is exposing child props and thus can be used from outside
 */
export const Sticky = (props: ISticky) => {
    const [loaded, setLoaded] = React.useState(false);
    const { stickyRef, sticky } = useSticky(props.observerRef);

    React.useEffect(() => {
        setLoaded(true);
    }, []);

    const height =
        typeof props.height === 'number'
            ? props.height
            : stickyRef.current
            ? stickyRef.current.offsetHeight
            : 0;

    /**
     * `height > 0` - meaning the actual height is declared (the component is initialized)
     *
     * @NOTE ain't gonna work if we have lazy loaded content on wrapped element
     */
    const stickyStyle: React.CSSProperties | null =
        height > 0 ? { pointerEvents: 'none', height } : null;
    const childrenStyle: React.CSSProperties = { pointerEvents: 'all' };

    return loaded ? (
        <>
            {/* Helper element which replaces the height of the elements and prevents jumping
            due to position: fixed */}
            <div style={{ height: sticky ? height : 0 }} />

            <StyledSticky ref={stickyRef} sticky={sticky} style={stickyStyle}>
                <div style={childrenStyle}>{props.children(sticky)}</div>
            </StyledSticky>
        </>
    ) : (
        props.children(sticky)
    );
};
